// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1B8f5","list":"BalanceDue_list__3Y9kS","listRow":"BalanceDue_listRow__2pEUQ","total":"BalanceDue_total__33P1h"};